import { useCallback } from 'react';
import { selectDidViewFraudDetectionIntro } from 'features/quests/store/selectors';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
export const useFraudDetection = (isCreateFlow) => {
    const navigation = useMainStackNavigation();
    const didViewFraudDetectionIntro = useAppSelector(selectDidViewFraudDetectionIntro);
    const handlePress = useCallback(() => {
        if (!didViewFraudDetectionIntro) {
            navigation.navigateDeprecated('FraudProtectionIntro');
            return;
        }
        if (isCreateFlow) {
            navigation.navigateDeprecated('DataProtectionSettings', {
                isCreateFlow: true,
            });
            return;
        }
        navigation.navigateDeprecated('DataProtectionScreen');
    }, [didViewFraudDetectionIntro, isCreateFlow]);
    return handlePress;
};
